import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "MailSent" }

import Icon from "@/components/ds/icon/Icon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MailSent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      "icon-id": "envelope",
      type: "s"
    })
  ]))
}
}

})